var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStarYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1838_17186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2432 12.25C10.1499 12.2504 10.0579 12.2284 9.97486 12.1859L6.99986 10.6284L4.02486 12.1859C3.92826 12.2367 3.81934 12.2593 3.71049 12.2513C3.60164 12.2433 3.49722 12.2049 3.40911 12.1405C3.321 12.0761 3.25273 11.9882 3.21205 11.8869C3.17138 11.7857 3.15994 11.675 3.17903 11.5675L3.76236 8.28337L1.35903 5.95004C1.28405 5.87521 1.23085 5.78138 1.20516 5.67861C1.17947 5.57584 1.18225 5.46801 1.21319 5.3667C1.247 5.26303 1.3092 5.17091 1.39272 5.1008C1.47623 5.03068 1.57773 4.98538 1.68569 4.97004L5.0107 4.48587L6.47486 1.49337C6.52263 1.39475 6.59721 1.31157 6.69006 1.25337C6.78291 1.19517 6.89028 1.16431 6.99986 1.16431C7.10945 1.16431 7.21681 1.19517 7.30966 1.25337C7.40252 1.31157 7.4771 1.39475 7.52486 1.49337L9.00653 4.48004L12.3315 4.9642C12.4395 4.97955 12.541 5.02485 12.6245 5.09496C12.708 5.16508 12.7702 5.2572 12.804 5.36087C12.835 5.46218 12.8378 5.57001 12.8121 5.67278C12.7864 5.77554 12.7332 5.86938 12.6582 5.9442L10.2549 8.27754L10.8382 11.5617C10.859 11.6711 10.8481 11.7841 10.8068 11.8875C10.7654 11.9908 10.6954 12.0802 10.6049 12.145C10.4992 12.2191 10.372 12.256 10.2432 12.25Z",
    fill: "#FF9200"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1838_17186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarYellow);
export default __webpack_public_path__ + "static/media/icon_star_yellow.fb109cc80640bcd040b91a58a7405a9b.svg";
export { ForwardRef as ReactComponent };